import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ToastProvider } from '@core';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { GetReopeningReasonsResult } from './get-reopening-reasons.result';

/**
 * Get Reopening Reasons Use Case
 *
 * Retrieves all active reopening reasons for the Reopen Case modal dropdown.
 * These are tenant-specific and seeded from master tenant provisioning.
 */
@Injectable({ providedIn: 'root' })
export class GetReopeningReasonsUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _toast = inject(ToastProvider);

  /**
   * Execute use case
   * @returns Observable with reopening reasons array
   */
  public execute(): Observable<GetReopeningReasonsResult> {
    return this._repository.getReopeningReasons().pipe(
      map((reasons) => ({ reasons })),
      catchError((error) => {
        this._toast.error(
          'Failed to load reopening reasons',
          'Please refresh and try again.'
        );
        return throwError(() => error);
      })
    );
  }
}
